import React, { useRef, useEffect } from 'react';
import classes from './PeaceCorps.module.css';
import Container from '../../UI/Container/Container';
import fullbrightLogo from '../../../assets/images/full-bright--logo.png';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const PeaceCorps = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const contentRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: contentRef.current,
        start: 'top 50%',
      },
    });

    timeline.to(contentRef.current, { opacity: 1, duration: 1, ease: 'sine.out' });
  });

  return (
    <div className={classes.PeaceCorps}>
      <div className={classes.LayerOne}></div>
      <div className={classes.LayerTwo}></div>
      <div className={classes.LayerThree}></div>
      <div className={classes.LayerFour}>
        <Container>
          <div ref={contentRef} className={classes.Content}>
            <div class={classes.LogoContainer}>
              <div class={classes.Logo}>
                <svg xmlns="http://www.w3.org/2000/svg" width="75.111" height="74.966" viewBox="0 0 75.111 74.966">
                  <g id="Group_1" data-name="Group 1" transform="translate(-212.34 549.688)">
                    <path
                      id="Path_1"
                      data-name="Path 1"
                      d="M37.469,0A37.485,37.485,0,0,0,0,36.449c9.656-1.62,20.3,3.761,26.225,7.457,12.752,7.952,23.4,7.562,29.082,3.639-4.581,4.045-13.776,5.837-26.229,1.506a49.448,49.448,0,0,0-16.189-3.068,25.052,25.052,0,0,0-11.3,2.363,37.4,37.4,0,0,0,6.9,12.906c6.188-5.751,14.952-7.595,29.422-7.09,9.146.319,14.885-1.893,18.262-5.43-2.768,3.627-7.647,6.148-14.547,7.49C29.2,58.641,21.94,61.463,17.977,69.5A37.481,37.481,0,1,0,37.469,0Z"
                      transform="translate(212.5 -549.688)"
                      fill="#002147"
                    />
                    <path
                      id="Path_2"
                      data-name="Path 2"
                      d="M271.725-523.487c-2.765.755-3.36,3.006-5.1,5.439a11.226,11.226,0,0,0-.348-3.221c-1.4-5.544-6.945-8.616-13.27-9.256-3.284-.331-6.075-.375-12.066-1.039.084,1.57,4.681,15.064,14.988,18.843a55.951,55.951,0,0,1-18.191-2.736l2.636,2.668-3.571-.073s21.04,21.427,32.4,8.672c6.446-7.238,2.254-14.951,8.525-16.992a4.98,4.98,0,0,0-6.008-2.3"
                      fill="#fff"
                    />
                    <path
                      id="Path_3"
                      data-name="Path 3"
                      d="M266.85-503.562c-7.154,3.495-16.389,3.187-26.64-9.43-7.6-9.356-16.687-13.005-24.8-13.769a37.316,37.316,0,0,0-2.918,13.534c9.655-1.621,20.294,3.751,26.224,7.449,12.751,7.953,23.4,7.563,29.083,3.638-4.583,4.045-13.776,5.838-26.23,1.505a49.461,49.461,0,0,0-16.189-3.066,25.021,25.021,0,0,0-11.3,2.365,37.4,37.4,0,0,0,6.9,12.906c6.189-5.752,14.954-7.6,29.425-7.094,16.09.561,21.641-6.7,22.322-15.249-1,2.764-2.519,5.57-5.879,7.211"
                      fill="#b71234"
                      stroke="#b71234"
                      strokeWidth="0.3"
                    />
                  </g>
                </svg>
              </div>
              <div class={classes.Logo}>
                <img src={fullbrightLogo} alt="Top Fullbright-producing college" />
              </div>
            </div>
            <p>
              Top <span>Peace Corps</span> and <span>Fulbright-producing</span> College
            </p>
            {/* <p>Top College</p> */}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default PeaceCorps;
